export const IS_USE_PRODUCTION_ENV = process.env.NEXT_PUBLIC_USE_PRODUCTION_ENV === '1';
